import React from 'react';
import { DataTable, Modal } from 'carbon-components-react';
import moment from 'moment';
import './DetailInformationAsset.css';
import funcTranslateHelper from '../../../../../i18next/funcTranslateHelper';

export default function DetailInformationAsset ({ open, setOpen, asset }) {
  const {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    TableHeader,
    TableToolbar
  } = DataTable;

  const handleCloseAndOpen = () => {
    setOpen(false);
  };

  function parseObject (key, value) {
    value['0'] = key;
    return value;
  }

  function parserTime (key, value) {
    const time = ['tx_creationTimeStamp', 'tx_timeStamp'];
    if (time.includes(key)) {
      return moment(new Date(value.replace(' +0000 UTC', 'Z').replace(' ', 'T'))).format('DD/MM/YYYY HH:mm:ss A Z UTC');
    } else {
      return value;
    }
  }

  const RenderTableBody = (asset, obj) =>
    Object.entries(asset).map(([key, value], i) => {
      if (typeof value === 'object' && Array.isArray(value) === false) {
        const keyValueArray = parseObject(key, value);
        return RenderTableBody(keyValueArray, asset);
      }

      return key === '0' ? (
        <TableRow key={i}>
          <TableCell style={{ fontWeight: '900' }}>{value}</TableCell>
          <TableCell />
        </TableRow>
      ) : typeof obj === 'object' ? (
        <TableRow key={i}>
          <TableCell style={{ paddingLeft: '50px' }}>{funcTranslateHelper(key)}</TableCell>
          <TableCell>{parserTime(key, value)}</TableCell>
        </TableRow>
      ) : (
        <TableRow key={i}>
          <TableCell>{funcTranslateHelper(key)}</TableCell>
          <TableCell>{parserTime(key, value)}</TableCell>
        </TableRow>
      );
    });

  return (
    <div>
      <div id='scroll' className='scroll-table'>
        <Modal
          open={open}
          focusTrap
          onRequestSubmit={handleCloseAndOpen}
          onSecondarySubmit={() => alert('historico')}
          passiveModal
          onRequestClose={handleCloseAndOpen}
          primaryButtonText='Cerrar ventana'
          secondaryButtonText='Historico del asset'
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
          className='bx--modal-container-asset-detail-history'
        >
          <DataTable
            style={{ width: '1000px' }}
            rows={[]}
            headers={[]}
            render={({ rows, headers, getHeaderProps }) => (
              <TableContainer
                title={`${asset.name}`}
                description={`${asset.assetType}`}
              >
                <TableToolbar>
                  {/* make sure to apply getBatchActionProps so that the bar renders */}
                </TableToolbar>
                <Table>
                  <TableHead>
                    <TableRow>
                      {['Nombre', 'Valor'].map((header, i) => (
                        <TableHeader key={i}>{header}</TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>{RenderTableBody(asset)}</TableBody>
                </Table>
              </TableContainer>
            )}
          />
        </Modal>
      </div>
    </div>
  );
}
